export default __webpack_public_path__ + "static/media/live-casino-cat-cn.86bcc95d.webp";